import React from "react";
import { connect } from "react-redux";
import type { RouteComponentProps } from "react-router";

import PageLoadingBar from "pages/common/PageLoadingBar";
import { retryPromise } from "utils/AppsmithUtils";
import type { InitPackageEditorPayload } from "ee/actions/packageInitActions";
import { initPackageEditor } from "ee/actions/packageInitActions";
import getBranchParam from "git/helpers/getBranchParam";

type UIPackageEditorLoaderProps = RouteComponentProps<{
  basePackageId: string;
}> & {
  initEditor: (payload: InitPackageEditorPayload) => void;
};
interface UIPackageIDELoaderState {
  Editor: React.JSXElementConstructor<UIPackageEditorLoaderProps> | null;
}

class UIPackageIDELoader extends React.Component<
  UIPackageEditorLoaderProps,
  UIPackageIDELoaderState
> {
  constructor(props: UIPackageEditorLoaderProps) {
    super(props);

    this.state = {
      Editor: null,
    };
  }

  componentDidMount() {
    const { initEditor, match } = this.props;
    const { basePackageId } = match.params;
    const branchName = getBranchParam();

    initEditor({ basePackageId, branchName });

    retryPromise(
      async () => import(/* webpackChunkName: "editor" */ "./UIPackageIDE"),
    ).then((module) => {
      this.setState({ Editor: module.default });
    });
  }

  render() {
    const { Editor } = this.state;

    return Editor ? <Editor {...this.props} /> : <PageLoadingBar />;
  }
}

// TODO: Fix this the next time the file is edited
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: any) => {
  return {
    initEditor: (payload: InitPackageEditorPayload) =>
      dispatch(initPackageEditor(payload)),
  };
};

export default connect(null, mapDispatchToProps)(UIPackageIDELoader);
